export const SET_JOBS = 'SET_JOBS';
export const SET_CITIES = 'SET_CITIES';
export const SET_PROJECT = 'SET_PROJECT';
export const SET_COMPANY_INFO = 'SET_COMPANY_INFO';
export const SET_INSTAGRAM_POST = 'SET_INSTAGRAM_POST';

export default {
  [SET_JOBS]: (state, jobs) => {
    state.jobs = jobs;
  },
  [SET_CITIES]: (state, cities) => {
    state.cities = cities;
  },
  [SET_PROJECT]: (state, project) => {
    state.project = project;
  },
  [SET_COMPANY_INFO]: (state, companyInfo) => {
    state.companyInfo = companyInfo;
  },
  [SET_INSTAGRAM_POST]: (state, post) => {
    state.instagram_post = post;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js